import React, { Component, createRef } from 'react'
import { Button as SButton, Icon } from 'semantic-ui-react'
import cn from 'classnames'
import RemoveButton from '@ui/RemoveButton'
import EditableField from '@ui/EditableField'

const DEFAULT_TEXT = 'Enter your text here'

class Button extends Component {
  ref = createRef()

  state = {}

  componentDidMount() {
    if (this.props.editable) this.init()
    if (this.ref.current) {
      this.ref.current.addEventListener('paste', this.pasteText)
    }
  }

  componentWillUnmount() {
    this.unmounted = true
  }

  init = callback => {
    const { children, content } = this.props
    const text = (children || content || '').trim() || DEFAULT_TEXT
    this.setState({ editing: false, staticText: text, currentText: text }, callback)
  }

  pasteText = evt => {
    evt.preventDefault()
    const text = evt.clipboardData.getData('text/plain')
    this.setState({ currentText: text ? text.trim() : '' }, () => {
      this.ref.current.innerText = text
    })
  }

  handleChange = text => this.setState({ currentText: text })

  resetText = () => {
    this.setState(
      ({ staticText }) => ({ currentText: staticText }),
      () => {
        this.ref.current.innerText = this.state.currentText
      }
    )
  }

  handleBlur = () => {
    setTimeout(() => {
      const { id, onChange } = this.props
      const { currentText, clearing } = this.state

      if (this.unmounted) {
        if (onChange && currentText) onChange({ id, text: currentText })
      } else {
        if (clearing) this.setState({ clearing: false })
        else {
          if (!currentText) this.resetText()
          else if (onChange) onChange({ id, text: currentText })
          this.setState({ editing: false })
        }
      }
    }, 100)
  }

  handleType = evt => {
    if (evt.keyCode === 13) {
      evt.stopPropagation()
      evt.preventDefault()
    }
  }

  handleFocus = () => this.setState({ editing: true })

  handleClear = () => {
    this.setState({ clearing: true, currentText: '' })
    this.ref.current.innerText = ''
    this.ref.current.focus()
  }

  handleClick = () => {
    const { id, onClick } = this.props
    if (onClick) onClick(id)
  }

  render() {
    const {
      id,
      onRemove,
      editable,
      primary,
      children,
      content,
      fluid,
      disabled,
      inactive,
      className,
      fitContent,
      icon
    } = this.props
    const { staticText, editing } = this.state
    const removable = onRemove && !editing

    return (
      <SButton
        className={cn('survey-button', className, {
          removable,
          editable,
          editing,
          inactive
        })}
        onClick={this.handleClick}
        fluid={fluid}
        primary={primary}
        disabled={disabled}
      >
        {icon && <Icon name={icon} className='custom-icon' />}
        {editable ? (
          <EditableField
            text={staticText}
            onChange={this.handleChange}
            className={'button-editable'}
            fitContent={fitContent}
            onBlur={this.handleBlur}
            blue
            bold
            hideBorder
            required
            editable
          />
        ) : (
          children || content
        )}
        {editing && (
          <Icon name='times' onClick={this.handleClear} className='clear-button' />
        )}
        {removable && <RemoveButton id={id} onClick={onRemove} rounded />}
      </SButton>
    )
  }
}

export default Button
